import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Observable, of } from 'rxjs';

import { BetslipError } from '../../../errors/betslip-error';
import { EditBetNotAllowed } from '../../../errors/early-payout/edit-bet-not-allowed';
import { IExtendedMessage, MessageFormatter } from './message-formatter';

@Injectable()
export class EditBetFailedErrorMessageFormatter extends MessageFormatter<EditBetNotAllowed> {
    constructor(private sitecore: Sitecore) {
        super();
    }

    format(error: EditBetNotAllowed): Observable<IExtendedMessage> {
        return of({
            title: this.sitecore.betslip.editBet.cashOutFailedTitle,
            message: error.cashOutErrorMessage!,
        });
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof EditBetNotAllowed;
    }
}
